var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClick = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 4A.25.25 0 0 1 4 3.75h8a.25.25 0 0 1 .25.25v2a.75.75 0 0 0 1.5 0V4A1.75 1.75 0 0 0 12 2.25H4A1.75 1.75 0 0 0 2.25 4v8c0 .966.784 1.75 1.75 1.75h2a.75.75 0 0 0 0-1.5H4a.25.25 0 0 1-.25-.25V4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.408 10.409a.75.75 0 0 0-.285-1.24L8.537 7.585a.75.75 0 0 0-.954.954l1.586 4.586a.75.75 0 0 0 1.24.285l.792-.793 1.092 1.091a1 1 0 1 0 1.414-1.414l-1.091-1.091.792-.793z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClick);
export default ForwardRef;